declare module "signalr-no-jquery" {
   //missing declarations
   export interface Connection {
      state: connectionState;
      stateChanged(callback: (states: { newState: connectionState, ondState: connectionState }) => void): void;
   }
}

export const enum connectionState {
   connecting = 0,
   connected = 1,
   reconnecting = 2,
   disconnected = 4
}